import React, { createContext, useContext } from 'react';
import { EngagementTranslations } from './constants';

const TRANSLATION_KEYS: Array<keyof EngagementTranslations> = [
  'react', 'comments', 'addComment', 'writeComment', 'writeReply', 'send', 'reply', 'edit', 'save', 'cancel',
  'delete', 'deleteConfirm', 'hide', 'hideConfirm', 'blockUser', 'blockConfirm', 'blockReason', 'blockHideComments',
  'blockedSuccess', 'blockedNotice', 'edited', 'loadOlder', 'showReplies', 'showMore', 'showLess', 'noComments', 'error',
  'moreEmojis', 'searchEmoji', 'reactionCount', 'addReaction', 'removeReaction', 'showComments', 'hideComments',
];

/** the texts from a host app's `engagement` translation block - a missing key is an empty string */
export const buildEngagementTranslations = (raw?: Partial<Record<string, string>> | null): EngagementTranslations =>
  TRANSLATION_KEYS.reduce((acc, key) => ({ ...acc, [key]: raw?.[key] ?? '' }), {} as EngagementTranslations);

const EngagementTranslationsContext = createContext<EngagementTranslations | null>(null);

/** each host app mounts this once with its own texts - every engagement component below reads them */
export const EngagementTranslationsProvider: React.FC<{
  t: EngagementTranslations;
  children: React.ReactNode;
}> = ({ t, children }) => (
  <EngagementTranslationsContext.Provider value={t}>{children}</EngagementTranslationsContext.Provider>
);

export const useEngagementTranslations = () => useContext(EngagementTranslationsContext);

/**
 * z-index for the popups of an engagement panel (emoji picker, comment menu, confirm dialogs) - set when the panel
 * sits inside a layer above antd's defaults, e.g. the video notification modal.
 */
const EngagementLayerContext = createContext<number | undefined>(undefined);
export const EngagementLayerProvider = EngagementLayerContext.Provider;
export const useEngagementZIndex = () => useContext(EngagementLayerContext);
